import { api } from './client';

export interface ChangePasswordPayload {
	currentPassword: string;
	newPassword: string;
	confirmNewPassword: string;
}

/**
 * Change the current user's password.
 *
 * The endpoint lives under `/v1/auth/` (not `/v1/iam/users/`) because the BFF
 * exempts this path from the `enforce_password_change` gate — a user forced
 * to change their password must be able to reach it even while every other
 * authenticated request is blocked.
 */
export async function changePassword(payload: ChangePasswordPayload): Promise<void> {
	await api.post('/v1/auth/change-password', payload);
}
